import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDurationMin } from "../shared/lib/format";

interface SleepTimerBannerProps {
  startedAt: string;
  onOpen: () => void;
}

// Rendered outside the tab switch in App.tsx so it stays visible (and tappable) no matter
// which view the user navigates to while the timer keeps running in the background.
export function SleepTimerBanner({ startedAt, onOpen }: SleepTimerBannerProps) {
  const { t } = useTranslation();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, []);

  const elapsedMin = Math.max(0, Math.round((now - new Date(startedAt).getTime()) / 60000));
  const duration = formatDurationMin(elapsedMin);

  return (
    <button
      type="button"
      className="sleep-timer-banner"
      onClick={onOpen}
      aria-label={t("sleepTimer.bannerAria", { duration })}
    >
      <span className="sleep-timer-banner-dot" aria-hidden="true" />
      <span aria-hidden="true">{t("sleepTimer.bannerLabel", { duration })}</span>
    </button>
  );
}
